module.exports = __webpack_public_path__ + "img/progress3.77002993.png";